// src/region/datasources/regionsData.ts

import type { WebContext } from "~/src/Shared/Types";
import type { RegionDTO } from "~/src/region/infrastructure/RegionDTO";
import type { MenuDTO } from "~/src/region/infrastructure/MenuDTO";

// competitions data (menu products) / webContext
const regionsKings: RegionDTO[] = [
  {
    id: 1,
    apiId: 13,
    competitionId: [3, 6],
    name: "Spain",
    slug: "espana",
    navVisible: true,
    storeUrl: "https://store.kingsleague.pro/",
    timeZone: "Europe/Madrid",
    cmsKey: "https://cms-es.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueOfficial",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleague",
      },
      {
        name: "twitter",
        url: "https://x.com/kingsleague",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleague/",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@kingsleague",
      },
      {
        name: "discord",
        url: "https://discord.gg/XMr4vsPrYM",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kings-league-spain.png",
      alt: "Kings League Spain",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-spain.jpg",
    leagueTitle: "Kings League Spain",
    ticketsUrl: "region-Tickets",
    ecalWidgetId: "67cf8fa89f82590008cf1690",
  },
  {
    id: 2,
    apiId: 57,
    competitionId: [5],
    name: "Americas",
    slug: "americas",
    navVisible: true,
    storeUrl: "https://storeamericas.kingsleague.pro",
    timeZone: "America/Mexico_City",
    cmsKey: "https://cms-am.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueAmericas",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleagueamericas",
      },
      {
        name: "twitter",
        url: "https://x.com/kingsleague_am",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleagueamericas/",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@kingsleagueamericas",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kl-americas.png",
      alt: "Kings League Openbank Americas",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-americas.jpg",
    leagueTitle: "Kings League Openbank Americas",
    ticketsUrl: "https://fanki.com.mx/es/Kings_League_Santander",
    ecalWidgetId: "67d0e4519cf4320008f55f20",
  },
  {
    id: 4,
    apiId: 1,
    competitionId: [10],
    name: "Italy",
    slug: "italia",
    navVisible: true,
    storeUrl: "https://storeitalia.kingsleague.pro",
    timeZone: "Europe/Rome",
    cmsKey: "https://cms-it.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueIT",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleague_it",
      },
      {
        name: "twitter",
        url: "https://x.com/KingsLeague_IT",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleague_it/",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kl-lottomatica-sport-italy.png",
      alt: "Kings League Lottomatica.sport",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-italy.jpg",
    leagueTitle: "Kings League Lottomatica.sport Italy",
    ticketsUrl: "https://www.ticketone.it/artist/kings-league/?affiliate=KOS",
    ecalWidgetId: "67d0e532d64ffc0008c46013",
  },
  {
    id: 6,
    apiId: 17,
    competitionId: [17],
    name: "Brazil",
    slug: "brazil",
    navVisible: true,
    storeUrl: "",
    timeZone: "America/Sao_Paulo",
    cmsKey: "https://cms-br.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueBrazil",
      },
      { name: "twitch", url: "https://www.twitch.tv/kingsleague_br" },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleague_br",
      },
      {
        name: "twitter",
        url: "https://x.com/Kings_LeagueBR",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleague_br/",
      },
      { name: "tiktok", url: "https://www.tiktok.com/@kingsleague_br" },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kings-league-brazil.png",
      alt: "Kings League Brazil",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-brazil.jpg",
    leagueTitle: "Kings League Brazil",
    ticketsUrl: "",
    ecalWidgetId: "67d0e557d64ffc0008c46014",
  },
  {
    id: 8,
    apiId: 10,
    competitionId: [21],
    name: "France",
    slug: "france",
    navVisible: true,
    storeUrl: "",
    timeZone: "Europe/Paris",
    cmsKey: "https://cms-fr.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueFrance",
      },
      { name: "twitch", url: "https://www.twitch.tv/kingsleague_fra" },
      {
        name: "twitter",
        url: "https://x.com/kingsleague_fr",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleague_fr/",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kings-league-france.png",
      alt: "Kings League France",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-france.jpg",
    leagueTitle: "Kings League France",
    ticketsUrl: "",
    ecalWidgetId: "67d0e5810ce7110008b6f888",
  },
  {
    id: 9,
    apiId: 25,
    competitionId: [11],
    name: "Germany",
    slug: "germany",
    navVisible: true,
    storeUrl: "",
    timeZone: "Europe/Berlin",
    cmsKey: "https://cms-de.kingsleague.pro",
    social: [
      { name: "twitch", url: "https://www.twitch.tv/kingsleaguede" },
      { name: "youtube", url: "https://www.youtube.com/@KingsLeagueDeutschland" },
      {
        name: "twitter",
        url: "https://x.com/KingsLeagueDEU",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsleague_de",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kl-germany.png",
      alt: "Kings League Germany",
      width: 312,
      height: 81,
    },
    ogImage: "/img/league-og-image/og-germany.jpg",
    leagueTitle: "Kings League Germany",
    ticketsUrl:
      "https://www.eventim.de/artist/kings-league-germany/kings-league-germany-3872846/?affiliate=KGE",
  },
  {
    id: 5,
    apiId: 204,
    competitionId: [18],
    name: "KWC Nations",
    slug: "kwc-nations",
    navVisible: true,
    storeUrl: "",
    timeZone: "UTC",
    cmsKey: "https://cms-es.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueOfficial",
      },
      {
        name: "twitter",
        url: "https://twitter.com/_KingsWorld",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsworld",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsworld/",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@kingsworld",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kwc-nations.png",
      alt: "Kings World Cup Nations",
      width: 431,
      height: 155,
    },
    ogImage: "/img/league-og-image/og-nations.jpg",
    leagueTitle: "Kings World Cup Nations",
    ticketsUrl: "",
    ecalWidgetId: "67d218c6c02eb90008afeccc",
  },
  {
    id: 3,
    apiId: 204,
    competitionId: [8, 9],
    name: "KWC Clubs",
    slug: "world-cup",
    navVisible: true,
    storeUrl: "",
    timeZone: "UTC",
    cmsKey: "https://cms-es.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueOfficial",
      },
      {
        name: "twitter",
        url: "https://twitter.com/_KingsWorld",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsworld",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/kingsworld/",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@kingsworld",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-kwc-clubs.png",
      alt: "Kings World Cup Clubs",
      width: 402,
      height: 155,
    },
    ogImage: "/img/league-og-image/og-clubs.jpg",
    leagueTitle: "Kings World Cup Clubs",
    ticketsUrl: "",
    ecalWidgetId: "68006a1014570a0008bca96a",
  },
  {
    id: 7,
    apiId: 204,
    competitionId: [0],
    name: "King of Kings",
    slug: "king-of-kings",
    navVisible: false,
    storeUrl: "",
    timeZone: "Europe/Rome",
    cmsKey: "https://cms-es.kingsleague.pro",
    social: [],
    footerLogo: {
      src: "/img/league-logos/Footer-king-of-kings.png",
      alt: "King of Kings",
      width: 160,
      height: 81.03,
    },
    ogImage: "/img/league-og-image/og-king-of-kings.jpg",
    leagueTitle: "King of Kings MediaMarkt",
    ticketsUrl: "",
  },
];

const regionsQueens: RegionDTO[] = [
  {
    id: 1,
    apiId: 13,
    competitionId: [4, 6],
    name: "Spain",
    slug: "espana",
    navVisible: true,
    storeUrl: "https://store.queensleague.pro/",
    timeZone: "Europe/Madrid",
    cmsKey: "https://cms-es.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueOfficial",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleague",
      },
      {
        name: "twitter",
        url: "https://x.com/QueensLeague",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/queensleague/?hl=es",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@queensleague",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-Queens-League-Oysho.svg",
      alt: "Queens League Oysho Spain",
      width: 312,
      height: 68,
    },
    ogImage: "/img/league-og-image/og-ql-spain.jpg",
    leagueTitle: "Queens League Oysho Spain",
    ticketsUrl: "region-Tickets",
  },
  {
    id: 2,
    apiId: 57,
    competitionId: [12],
    name: "Americas",
    slug: "americas",
    navVisible: true,
    storeUrl: "",
    timeZone: "America/Mexico_City",
    cmsKey: "https://cms-am.kingsleague.pro",
    social: [
      {
        name: "youtube",
        url: "https://www.youtube.com/@KingsLeagueAmericas",
      },
      {
        name: "twitch",
        url: "https://www.twitch.tv/kingsleagueamericas",
      },
      {
        name: "twitter",
        url: "https://x.com/queensleagueam_",
      },
      {
        name: "instagram",
        url: "https://www.instagram.com/queensleagueam/",
      },
      {
        name: "tiktok",
        url: "https://www.tiktok.com/@queensleagueamericas",
      },
      {
        name: "facebook",
        url: "https://www.facebook.com/queensleagueoyshoamericas",
      },
    ],
    footerLogo: {
      src: "/img/league-logos/Footer-Queens-League-Oysho-Americas.png",
      alt: "Queens League Oysho Americas",
      width: 312,
      height: 74.2,
    },
    ogImage: "/img/league-og-image/og-ql-americas.jpg",
    leagueTitle: "Queens League Oysho Americas",
    ticketsUrl: "",
  },
];

// navigation menus / webContext
const navigationMenuKings: MenuDTO[] = [
  {
    region: "espana",
    regionId: 1,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["es"],
      },
      {
        name: "fantasy",
        link: "https://kingsleague.hro.gg/",
      },
    ],
  },
  {
    region: "americas",
    regionId: 2,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["es"],
      },
    ],
  },
  {
    region: "italia",
    regionId: 4,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["it"],
      },
    ],
  },
  {
    region: "brazil",
    regionId: 6,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["pt"],
      },
    ],
  },
  {
    region: "france",
    regionId: 8,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["fr"],
      },
    ],
  },
  {
    region: "germany",
    regionId: 9,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
    ],
  },
  {
    region: "world-cup",
    regionId: 3,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "legends",
            link: "PlayersLegend",
          },
        ],
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "tournament",
        link: "region-Tournament",
      },
      {
        name: "tierList",
        link: "region-TierList",
      },
    ],
  },
  {
    region: "kwc-nations",
    regionId: 5,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "region-PlayersDraft",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "tournament",
        link: "region-Tournament",
      },
      {
        name: "tierList",
        link: "region-TierList",
      },
    ],
  },
];

const navigationMenuQueens: MenuDTO[] = [
  {
    region: "espana",
    regionId: 1,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["es"],
      },
    ],
  },
  {
    region: "americas",
    regionId: 2,
    children: [
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "#",
        children: [
          {
            name: "playersDraft",
            link: "region-PlayersDraft",
          },
          {
            name: "12-13",
            link: "region-PlayersVariable",
          },
          {
            name: "tryouts",
            link: "region-Draft",
          },
          {
            name: "reserves",
            link: "region-DraftReserves",
          },
        ],
      },
      {
        name: "stats",
        link: "#",
        children: [
          { name: "statsPlayers", link: "region-stats" },
          { name: "statsTeams", link: "region-stats-teams" },
        ],
      },
      {
        name: "news",
        link: "region-news",
        lang: ["es"],
      },
    ],
  },
];

// footer menus / webContext
const footerMenuKings: MenuDTO[] = [
  {
    region: "espana",
    regionId: 1,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "squadSimulator",
        link: "region-SquadSimulator",
      },
      {
        name: "news",
        link: "region-news",
      },
      { name: "mercato", link: "region-Mercato", lang: ["en", "es"] },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "tickets",
        link: "region-Tickets",
      },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "americas",
    regionId: 2,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "italia",
    regionId: 4,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      { name: "circulars", link: "region-circulars-CircularsIt", lang: ["it"] },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      /*{
        name: "contact",
        link: "region-ContactUs",
      },*/
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "brazil",
    regionId: 6,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "squadSimulator",
        link: "region-TeamSimulator",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "france",
    regionId: 8,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "germany",
    regionId: 9,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "world-cup",
    regionId: 3,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "legends",
        link: "PlayersLegend",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "tournament",
        link: "region-Tournament",
      },
      {
        name: "tierList",
        link: "region-TierList",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "kwc-nations",
    regionId: 5,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "players",
        link: "region-PlayersDraft",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "tournament",
        link: "region-Tournament",
      },
      {
        name: "tierList",
        link: "region-TierList",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "king-of-kings",
    regionId: 7,
    children: [
      {
        name: "qualifiersSpain",
        link: "region",
      },
      {
        name: "qualifiersAmericas",
        link: "region-KokQualifiersAmericas",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
];

const footerMenuQueens: MenuDTO[] = [
  {
    region: "espana",
    regionId: 1,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "squadSimulator",
        link: "region-SquadSimulator",
      },
      {
        name: "news",
        link: "region-news",
      },
      { name: "mercato", link: "region-Mercato", lang: ["es", "en"] },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "tickets",
        link: "region-Tickets",
      },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
  {
    region: "americas",
    regionId: 2,
    children: [
      {
        name: "teams",
        link: "region-Teams",
      },
      {
        name: "playersDraft",
        link: "region-PlayersDraft",
      },
      {
        name: "12-13",
        link: "region-PlayersVariable",
      },
      {
        name: "matches",
        link: "region-Matches",
      },
      {
        name: "tables",
        link: "region-Tables",
      },
      {
        name: "stats",
        link: "region-stats",
      },
      {
        name: "draft",
        link: "region-Draft",
      },
      {
        name: "news",
        link: "region-news",
      },
      {
        name: "regulation",
        link: "region-Regulation",
      },
      {
        name: "media",
        link: "region-MediaAccreditationInfo",
      },
      {
        name: "contact",
        link: "region-ContactUs",
      },
      {
        name: "careers",
        link: "https://kosmos.teamtailor.com/",
      },
    ],
  },
];

export const getWebContextRegionsData = (webContext: WebContext) => {
  if (webContext === "queens") {
    return regionsQueens;
  } else {
    return regionsKings;
  }
};

export const getWebContextNavigationMenu = (webContext: WebContext) => {
  if (webContext === "queens") {
    return navigationMenuQueens;
  } else {
    return navigationMenuKings;
  }
};

export const getWebContextFooterMenu = (webContext: WebContext) => {
  if (webContext === "queens") {
    return footerMenuQueens;
  } else {
    return footerMenuKings;
  }
};

export const getCompetitionIdsToMapInfo = (webContext: WebContext): number[] => {
  const regions = getWebContextRegionsData(webContext);
  const competitionIds = regions.map(r => r.competitionId);
  return [...new Set(competitionIds.flat())].filter(n => n !== 0);
};

export const getWebContextAllSocialProfilesSchema = (webContext: WebContext): string[] => {
  const regions = getWebContextRegionsData(webContext);
  const socialProfiles = regions.flatMap(r => r.social);

  return [...new Set(socialProfiles.map(sp => sp.url))];
};
